export default __webpack_public_path__ + "static/media/resume.668a33e3.pdf";